/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2022 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  function setEqualHeight() {
    const $cards = $('.card-location__slider');
    // Reset the height to auto to calculate natural height
    $cards.css('height', 'auto');
    // Find the tallest card
    let maxHeight = 0;
    $cards.each(function () {
      const cardHeight = $(this).outerHeight();
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });
    // Set the height of all cards to the tallest height
    $cards.css('height', `${maxHeight}px`);
  }

  const multiSliders = document.querySelectorAll('.card-location__multi-sliders');

  multiSliders.forEach(slider => {
    // Count the number of slides/items inside the slider
    const itemCount = $(slider).find('.card-location__slider').length;

    // Determine slidesToShow for 900 breakpoint
    let slidesToShow900;
    if (itemCount === 1) {
      slidesToShow900 = 1;
    } else if (itemCount === 2) {
      slidesToShow900 = 1;
    } else {
      slidesToShow900 = 2;
    }

    // Determine slidesToShow for 1330 breakpoint
    let slidesToShow1330;
    if (itemCount === 1) {
      slidesToShow1330 = 1;
    } else if (itemCount === 2) {
      slidesToShow1330 = 2;
    } else {
      slidesToShow1330 = 3;
    }

    // Initialize Slick slider using jQuery, since Slick requires it
    $(slider).slick({
      slidesToShow: 1,
      infinite: false,
      variableWidth: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1330,
          settings: {
            slidesToShow: slidesToShow1330,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: slidesToShow900,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        },
      ],
    });

    // Recalculate heights when the Slick slider position is reset
    $(slider).on('setPosition', setEqualHeight);
  });

  // Set equal heights after initializing Slick slider
  document.addEventListener('DOMContentLoaded', setEqualHeight);

  window.addEventListener('resize', () => {
    multiSliders.forEach(slider => {
      $(slider).slick('resize');
    });
    setEqualHeight();
  });
}(jQuery));
